import { render, staticRenderFns } from "./ComingSoonFeatureVote.vue?vue&type=template&id=64f15630&scoped=true"
import script from "./ComingSoonFeatureVote.vue?vue&type=script&lang=js"
export * from "./ComingSoonFeatureVote.vue?vue&type=script&lang=js"
import style0 from "./ComingSoonFeatureVote.vue?vue&type=style&index=0&id=64f15630&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f15630",
  null
  
)

export default component.exports